import * as React from "react";
import * as _ from "lodash";
import { connect } from "react-redux";
import { IStore } from "../../../redux/initialState";
import device from '../../../services/mini/device';

function ConceptVideoToolWrapper({ children, isAvailable }) {
  const isDesktop = device.isDesktop();

  if (isDesktop && isAvailable) {
    return <>{children}</>;
  }
  return <></>;
}

function mapStateToProps({ config, user }: IStore) {
  return {
    isAvailable: config?.features?.conceptVideoTool?.enabled === true && user.capabilities?.videoToolAvailable,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConceptVideoToolWrapper);
